export default __webpack_public_path__ + "static/media/day2_working.23a0c34c.jpg";